import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/home/program/front/git/cloud_space_manage_front/node_modules/_@babel_runtime-corejs2@7.24.0@@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/program/front/git/cloud_space_manage_front/node_modules/_@babel_runtime-corejs2@7.24.0@@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import router from "./router";
import store from "./store";
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
import Cookies from 'js-cookie';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login']; // no redirect whitelist

router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var hasToken, hasGetUserInfo, userInfo, role, account_type, roles;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // start progress bar
          NProgress.start();

          // set page title
          document.title = getPageTitle(to.meta.title);

          // determine whether the user has logged in
          hasToken = getToken();
          if (!hasToken) {
            _context.next = 32;
            break;
          }
          //if (to.path === '/login') {
          //  // if is logged in, redirect to the home page
          //  next({ path: '/' })
          //  NProgress.done()
          //} else {
          hasGetUserInfo = store.getters.name;
          console.log(hasGetUserInfo);
          if (!hasGetUserInfo) {
            _context.next = 10;
            break;
          }
          next();
          _context.next = 30;
          break;
        case 10:
          _context.prev = 10;
          _context.next = 13;
          return store.dispatch('user/getInfo');
        case 13:
          userInfo = _context.sent;
          console.log(userInfo);
          role = '';
          account_type = Cookies.get('emis_yun_account_type');
          console.log('account_type', account_type);
          roles = [];
          store.dispatch('GenerateRoutes', {
            roles: roles,
            role: role,
            account_type: account_type
          }).then(function () {
            // 生成可访问的路由表
            router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
            //console.log('addRoutersaddRoutersaddRouters',store.getters.addRouters)
            next(_objectSpread({}, to)); // hack方法 确保addRoutes已完成
          });
          next();
          _context.next = 30;
          break;
        case 23:
          _context.prev = 23;
          _context.t0 = _context["catch"](10);
          _context.next = 27;
          return store.dispatch('user/resetToken');
        case 27:
          Message.error(_context.t0 || 'Has Error');
          next("/login?redirect=".concat(to.path));
          NProgress.done();
        case 30:
          _context.next = 33;
          break;
        case 32:
          /* has no token*/

          if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next();
          } else {
            // other pages that do not have permission to access are redirected to the login page.
            next("/login?redirect=".concat(to.path));
            NProgress.done();
          }
        case 33:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[10, 23]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});